module.exports = __webpack_public_path__ + "media/images/landing/browser_perspective.en-original-cc398702f6d7c7f10820e033c9796f75.png";